<ion-row class="order-page-toolbar" role="region" aria-label="Order page toolbar">
	<ion-icon
		(click)="onBackClick()"
		(keydown.enter)="onBackClick()"
		(keydown.space)="onBackClick()"
		[class.ion-hide]="hideElements"
		class="pointer"
		size="large"
		src="../../../assets/dean_and_david/back.svg"
		aria-label="Back"
		role="img"
		tabindex="0"
	></ion-icon>
	<ion-col class="ion-no-padding">
		<ion-row class="title-block" role="region" aria-label="Title block">
			<h2 class="title">{{ title }}</h2>
		</ion-row>
	</ion-col>
	<app-burger-btn [class.ion-hide]="hideElements"></app-burger-btn>
	<!-- <ion-buttons class="close" (click)="onClose()">
		<ion-icon size="large" name="close" role="img" aria-label="Close icon"></ion-icon>
	</ion-buttons> -->
</ion-row>
